import Vue from 'vue'
import _ from 'lodash'

const url = 'storage'
const files = {
  namespaced: true,
  state: {
    files: []
  },
  // CRUD / RESTful actions
  mutations: {
    SET(state, data) {
      state.files = data
    },
    NEW(state, data) {
      state.files.unshift(data)
    },
    UPD(state, data) {
      const index = state.files.findIndex(t => t.id == data)
      if(index !== -1) {
        state.files.splice(index, 1, data)
      }
    },
    DEL(state, data) {
      state.files = state.files.filter(res => res.id != data.id)
    },
    DEL_MUL() {

    }
  },
  actions: {
    async fetch({commit}) {
      const response = await Vue.prototype.$axios.get(url)
      commit('SET', response.data)
    },
    async create({commit}, client) {
      Vue.prototype.$axios.post(url, client).then(res => {
        Vue.prototype.$toastr.s('Created new client.')
        commit('NEW', res.data)
      }).catch(err => {
        console.log(err)
        Vue.prototype.$toastr.e('Could note create client.')
      })
    },
    async update({commit}, client) {
      const response = await Vue.prototype.$axios.put(url, client)
      commit('UPD_CLIENT', response.data)
    },
    async remove({commit}, client) {
      const response = await Vue.prototype.$axios.delete(url + '/' + client.id)
      commit('DEL', response.data)
    },
    async removeMultiple({commit}, payload) {
      Vue.prototype.$axios.delete(url + '/', {data: payload}).then(res => {
        console.log(res.data.res)
        _.forEach(res.data.res, deleted => {
          console.log(deleted)
          Vue.prototype.$toastr.s(deleted.base)
        })
        Vue.prototype.$axios.get(url).then(response => {
          commit('SET', response.data)
        })
      })
    }
  },
  getters: {
    all: state => state.files
  }
}

export default files